import React, { useContext, useState } from "react";
import { ButtonProps, AddButton, Aside } from "sprint-common-web";

import { EpisodeDetails } from "../../../../TvSeriesDetails";
import { SeasonEpisodeListingContext } from "../context/SeasonEpisodeListingContext";
import { CreateEpisodeForm } from "../create-episode-form/CreateEpisodeForm";

export type CreateEpisodeButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    isLabeled?: boolean;
    onClick?(): void;
};

export const CreateEpisodeButton: React.FunctionComponent<CreateEpisodeButtonProps> = (
    props: CreateEpisodeButtonProps
) => {
    const { addNewEpisode } = useContext(SeasonEpisodeListingContext);
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsAsideOpen(true);
        if (props.onClick) {
            props.onClick();
        }
    };

    const closeCreateEpisodeSidebar = () => {
        setIsAsideOpen(false);
    };

    const handleCreateEpisodeFormSubmit = (newEpisode: EpisodeDetails) => {
        addNewEpisode(newEpisode);
        closeCreateEpisodeSidebar();
    };

    return (
        <>
            <AddButton
                onClick={handleClick}
                isLabeled={props.isLabeled}
                label="Add"
                disabled={props.disabled}
                styles={props.styles}
            />
            <Aside isOpen={isAsideOpen} type="form" headerText="Add Episode" onDismiss={closeCreateEpisodeSidebar}>
                <CreateEpisodeForm onCancel={closeCreateEpisodeSidebar} onSubmit={handleCreateEpisodeFormSubmit} />
            </Aside>
        </>
    );
};
